import React, { Component, PureComponent } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
    WithStyles,
    createStyles,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Grid,
    TextField,
    Radio,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@material-ui/core';
import CustomInfoIcon from './CustomInfoIcon';

const styles = (theme: Theme) => createStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&>:first-child': {
            background: '#fff'
        }
    },
    checkedIcon: {
        backgroundColor: 'rgb(29 125 234)',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    formControlLabel: {
        fontSize: 16,
        color: '#333333'
    },
    icon: {
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },

    infoContainer: {
        padding: '6px 10px 0px 0px',
        marginLeft: -10,
        marginRight: 16,
        '&>:first-child': {
            '&>button':{
                height: 25
            }
        }
    },

    graceCard: {
        padding: '34px 18px 33px',
        background: '#fff',
        borderRadius: 4
    },

    awardCard: {
        padding: '12px 18px 6px',
        background: '#fff',
        borderRadius: 4
    },

    whiteBox: {
        height: 65,
        background: 'rgb(255 255 255)',
        padding: '13px 12px'
    },

    widthSM: {
        maxWidth: 470,
    },

    widthMD: {
        maxWidth: 766
    },

    fontSM: {
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgb(51 51 51)',
        padding: 12
    },

    fontSizeSM: {
        fontSize: 12
    },

    marginTopSM: {
        marginTop: 12
    },

    graceTextField: {
        margin: '-4px 0px',
        '& input': {
            padding: '3px 0px 2px 6px',
            width: 80,
            height: 28,
            background: 'rgb(255 255 255)',
            border: '1px solid rgb(223 223 223)',
            borderRadius: 4
        },
        "& input::-webkit-clear-button, & input::-moz-clear-button, & input::-webkit-outer-spin-button, & input::-moz-outer-spin-button, & input::-webkit-inner-spin-button & input::-moz-inner-spin-button": {
            display: "block",
            height: 35,
            width: 18,
            padding: '0px 4px'
        },
        "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
            opacity: 1
        },
        "& input[type=number]":{
            '-moz-appearance': 'textfield'
        }
    },

    labelText: {
        '& :nth-child(2)': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            fontSize: 16,
            lineHeight: '19px',
            color: '#333333',
            marginTop: 20
        }
    },

    marginTopMD: {
        margin: '8px 0px 0px',
    },

    okButton: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 14,
        lineHeight: '19px',
        letterSpacing: '0.5px',
        color: '#FFFFFF',
        background: '#1D7DEA',
        padding: '4px 22px',
        width: 150,
        borderRadius: 4,
        '&:hover': {
            background: '#1D7DEA'
        }
    },

    tableCell: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '18px',
        textAlign: 'center',
        color: 'rgb(51, 51, 51)'
    },
    borderNone: {
        border: 'none',
        height: 40
    },
    paddingSM: {
        padding: 0,
        minWidth: 130
    },
    tableRow: {
        height: 20
    },
    tableContainer: {
        height: 'auto',
        background: '#FCEEEE',
        border: '1px solid #E2E2E2',
        maxHeight: 400,
        overflowY: 'auto',
        borderRadius: 4,
        margin: '15px 0px',
        padding: '6px 0px 12px',
        width: 766,
        '& td': {
            borderBottom: '1px solid rgb(0 0 0 / 0%)',
            fontSize: 14,
            color: '#666666',
            padding: '4px 24px 4px 24px'
        }
    },
    noLabel: {
        marginTop: theme.spacing.unit * 3,
    }
});

interface AwardGraceMarksProps extends WithStyles<typeof styles> {
    type: string,
    subType: string,
    correctAnswer: any,
    alternateAnswer: boolean,
    setAlternateAnswer: Function,
    changeHandler: Function,
    handleFormChange: Function,
    eventFired: Function,
    history: any;
    updateContent: Function,
    matrixCorrectAnswer: any,
    matrixOptionContent: any,
    classes: any
}

interface AwardGraceMarksState {
    showDialog: boolean,
    title: string,
    isAlternate: boolean
}

class AwardGraceMarks extends PureComponent<AwardGraceMarksProps, AwardGraceMarksState> {

    constructor(props: AwardGraceMarksProps) {
        super(props);
        this.state = { showDialog: false, title: '', isAlternate: false }
        this.handleAnswerChange = this.handleAnswerChange.bind(this);
        this.handleGraceAward = this.handleGraceAward.bind(this);
        this.handleAlternateAnswer = this.handleAlternateAnswer.bind(this);
    }

    componentDidMount() {

    }

    handleAnswerChange = () => {
        //add your functional code here
    }

    handleDialogClose = () => {
        this.setState({ showDialog: !this.state.showDialog })
    }

    handleGraceAward() {
        const { classes } = this.props;
        const { showDialog, title, isAlternate } = this.state;
        this.setState({ showDialog: !this.state.showDialog, title: 'Award Grace Marks', isAlternate: false })
    }

    handleAlternateAnswer(event: any) {
        const {
            setAlternateAnswer,
            correctAnswer,
            changeHandler
        } = this.props;
        const { name, checked } = event.target;
        if (!checked) {
            if (correctAnswer.data.length > 1) {
                const _correctAnswer = JSON.parse(JSON.stringify(correctAnswer))
                _correctAnswer.data.splice(1)
                changeHandler(_correctAnswer)
            }
        }
        setAlternateAnswer(checked)
    }

    addGraceCard(classes: any) {
        return (
            <>
                <Grid container justify="center" alignItems="center" className={[classes.graceCard,
                classes.widthSM].join(' ')}>
                    <Grid item xs={12}>
                        <span className={classes.fontSM}>
                            Set Grace Marks :
                                </span>
                        &nbsp; &nbsp;
                                <span>
                            <TextField
                                variant="outlined"
                                classes={{ root: classes.graceTextField }}
                                type="number" inputProps={{ min: "0", max: "10", step: "1" }} />
                        </span>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel
                                classes={{ root: classes.labelText }}
                                className={classes.marginTopMD}
                                control={<Radio onChange={this.handleAnswerChange} name="alterAnswer" />}
                                label="Grace Marks to be given to only students who have attempted this question"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                classes={{ root: classes.labelText }}
                                className={classes.marginTopMD}
                                control={<Radio onChange={this.handleAnswerChange} name="alterAnswer" />}
                                label="Grace Marks to be given to all the students who have attempted the test"
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
            </>
        )
    }

    addAwardCard(classes: any) {
        return (
            <>
                <Grid container alignItems="center" className={[classes.awardCard,
                classes.widthMD].join(' ')}>
                    <Grid justify="flex-start" alignItems="flex-start">This change will impact:</Grid>
                    <Grid className={classes.tableContainer}>
                        <Table>
                            <TableHead>
                                <TableRow classes={{ head: classes.tableRow }}>
                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Test Name</TableCell>
                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Test Id</TableCell>
                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Students attempt</TableCell>
                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Center</TableCell>
                                    <TableCell padding='none' align="center" classes={{ head: [classes.tableCell, classes.borderNone, classes.paddingSM].join(' ') }}>Created By</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>

                                <TableRow key={1} classes={{ root: classes.tableRow }}>
                                    <TableCell align="center">Full Test Jee Main-1</TableCell>
                                    <TableCell align="center">T-120823</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">Dwarika</TableCell>
                                    <TableCell align="center">JK</TableCell>
                                </TableRow>

                                <TableRow key={2} classes={{ root: classes.tableRow }}>
                                    <TableCell align="center">Full Test Jee Main-1</TableCell>
                                    <TableCell align="center">T-120823</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">Dwarika</TableCell>
                                    <TableCell align="center">JK</TableCell>
                                </TableRow>

                                <TableRow key={3} classes={{ root: classes.tableRow }}>
                                    <TableCell align="center">Full Test Jee Main-1</TableCell>
                                    <TableCell align="center">T-120823</TableCell>
                                    <TableCell align="center">23</TableCell>
                                    <TableCell align="center">Dwarika</TableCell>
                                    <TableCell align="center">JK</TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </Grid>

                </Grid>
            </>
        )
    }

    render() {
        const {
            classes,
            matrixOptionContent,
            alternateAnswer,
            setAlternateAnswer
        } = this.props;
        const { showDialog, title, isAlternate } = this.state;
        return (
            <>
                <FormGroup row>
                    <FormControlLabel
                        control={<Checkbox
                            classes={{ root: classes.root }}
                            onChange={(event: any) => { this.handleAlternateAnswer(event) }}
                            disableRipple
                            checked={alternateAnswer}
                            color="default"
                            checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            icon={<span className={classes.icon} />}
                            name="alterAnswer" />}
                        classes={{ label: classes.formControlLabel }}
                        label="Add alternate answer"
                    />
                    <span className={classes.infoContainer}>
                        <CustomInfoIcon
                            infoDialogContentType="Add alternate answer"
                            isInfoIcon={true}
                            isRightArrow={false}
                            isCenterArrow={true}
                            knowMoreAbout={false}
                            dialogTitle="Add alternate answer"
                            imageURL="/assets/svg/infoIcon/myLibrary/alt-answer.svg"
                            dialogPara="Author can now mark additional options as correct answers, even after the test has been submitted. If a student selects any one of these options, it will be considered as correct."
                            details="Click to know more"
                            toolTipDirection="top" /></span>

                    {/* <FormControlLabel                  for future purpose 
                        control={<Checkbox
                            onChange={this.handleGraceAward}
                            classes={{ root: classes.root }}
                            disableRipple
                            color="default"
                            checkedIcon={<span className={[classes.icon, classes.checkedIcon].join(' ')} />}
                            icon={<span className={classes.icon} />}
                            name="alterAnswer" />}
                            classes={{label: classes.formControlLabel}}
                        label="Award Grace Marks"
                    />
                    <span className={classes.infoContainer}>
                        <CustomInfoIcon
                            infoDialogContentType="Award Grace Marks"
                            isInfoIcon={true}
                            isRightArrow={true}
                            isCenterArrow={false}
                            knowMoreAbout={false}
                            dialogTitle="Award Grace Marks"
                            imageURL="/assets/svg/infoIcon/myLibrary/grace-award.svg"
                            dialogPara="Add grace marks on clicking of 'Re-publish' button. These marks will be awarded to the student irrespective of any answer selected."
                            details="Click to know more"
                            toolTipDirection="top" /></span> */}
                </FormGroup>


                {/*  
                <MyPATDialog
                    dialogOpen={showDialog}
                    dialogHasActions={true}
                    dialogHeading={title}
                    isAlignCenter={true}
                    customButtonVariant = "withoutBorderCloseIcon"
                    onDialogClose={this.handleDialogClose.bind(this)}
                    isCustomBackground={true}
                    otherDialogProps={{
                        fullWidth: false,
                        maxWidth: false
                    }}
                    customDialogActions={
                        <>
                            <Grid container justify="flex-end" alignItems="flex-end">
                                <Button onClick={this.handleDialogClose.bind(this)} className={classes.cancelButton}>Cancel</Button>
                                <Button onClick={this.handleDialogClose.bind(this)} className={classes.okButton}>Add to Queue</Button>
                            </Grid>
                        </>
                    }
                >
                    {!isAlternate ? this.addGraceCard(classes) : this.addAwardCard(classes) } 

                    <Grid container className={[(!isAlternate ? classes.widthSM : classes.widthMD), classes.marginTopSM].join(' ')}>
                        <Grid xs={12}>
                            {
                                !isAlternate &&
                                <Typography variant="body1" className={classes.fontSM}>
                                    <strong>* NOTE :</strong> Grace Marks will be awarded to students for this test only. Please edit and correct this question for future use.
                                </Typography>
                            }
                            <Typography variant="body1" className={[classes.fontSizeSM, (!isAlternate && classes.whiteBox)].join(' ')}>
                                <strong>Add to Queue:</strong> All this changes to the Re-publish Queue to regenerate results for multiple Questions/Tests at once from MyLibrary Homepage
                            </Typography>
                        </Grid>
                    </Grid>


                </MyPATDialog> */}
            </>
        );
    }
};

// @ts-ignore 
export default withStyles(styles)(AwardGraceMarks);